module.exports = __webpack_public_path__ + "img/img (23).ee8d591c.jpg";